import {createSelector} from 'reselect'
import {generatePath} from '@modifi/router'

import {ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_BY_ID} from '../../../../routes/constants'
import {selectDirectDebitBankAccounts} from '../../../../data/direct-debit-account'

export const selectBankAccountSummaryData = createSelector(
  selectDirectDebitBankAccounts,
  bankAccounts => {
    const summaryData = bankAccounts.map(bankAccount => {
      const accountHolder = bankAccount?.accountHolder
      return {
        route: generatePath(ROUTE_COMPANY_PROFILE_DIRECT_DEBIT_ACCOUNT_DETAILS_BY_ID, {
          externalBankAccountId: bankAccount?.externalId,
        }),
        accountHolder,
        accountNumber: bankAccount?.accountNumber || '',
      }
    })
    return summaryData
  }
)
